"use strict"

import axios from "axios";

const state = function() {
  return {
    loading: false,
    managers: [],
    pagination: {
      page: 1,
      total: 1
    },
    departments: [],
    roles: [
      { code: 'admin_resercher', name: 'Администратор' },
      { code: 'resercher', name: 'Менеджер по персоналу' },
      // { code: 'shop_director', name: 'Директор магазина' },
      { code: 'security', name: 'Служба безопасности' },
      { code: 'hr', name: 'Отдел кадров' }
    ],
    // get parameters for link request
    size: 10,
    searchQuery: '',
    selectedDepartments: []
  };
};

const getters = {
  getDepartmentsForSelect: state => {
    return state.departments.map(x => {
      return { id: x.id, name: x.name };
    });
  },

  getManagersPagination: state => {
    return {
      totalPages: Math.ceil(state.pagination.total / state.size),
      pageNumber: state.pagination.page,
      count: state.size
    }
  }
};

const mutations = {
  SET_MANAGERS: (state, payload) => {
    state.managers = payload;
  },

  SET_PAGINATION: (state, payload) => {
    state.pagination = payload;
  },

  SET_DEPARTMENTS: (state, payload) => {
    state.departments = payload;
  },

  SET_PAGE: (state, payload) => {
    state.pagination.page = payload;
  },

  SET_SIZE: (state, payload) => {
    state.size = payload;
  },

  SET_SEARCH_QUERY: (state, payload) => {
    state.searchQuery = payload;
  },

  SET_SELECTED_DEPARTMENTS: (state, payload) => {
    state.selectedDepartments = payload;
  },

  setLoading: (state, payload) => {
    state.loading = payload;
  }
};

const actions = {
  async fetchAll({ dispatch }) {
    await dispatch('fetchManagers');
    await dispatch('fetchDepartments');
  },

  async fetchManagers({ commit, state }) {
    commit("setLoading", true);

    let getParams = `?page=${state.pagination.page}&size=${state.size}`;

    if (state.searchQuery.length > 0) {
      getParams += `&search=${state.searchQuery}`
    }
    if (state.selectedDepartments.length > 0) {
      state.selectedDepartments.forEach(item => {
        getParams += `&departments[]=${item}`
      });
    }

    await axios.get(`/1.0/spec-private/sportmaster/users${getParams}`)
      .then(x => {
        commit("SET_MANAGERS", x.data.data);
        commit("SET_PAGINATION", x.data.meta);
      })
      .finally(() => {
        commit("setLoading", false);
      })
  },

  async fetchDepartments({ commit }) {
    commit("setLoading", true);;

    await axios.get(`/1.0/spec-private/sportmaster/departments`)
      .then(x => {
        commit("SET_DEPARTMENTS", x.data.data);
      })
      .finally(() => {
        commit("setLoading", false);
      })
  },

  async setPage({ commit, dispatch }, page) {
    commit('SET_PAGE', page);

    await dispatch('fetchManagers');
  },

  async setSize({ commit, dispatch }, size) {
    commit('SET_SIZE', size);

    await dispatch('fetchManagers');
  },

  async makeSearchByUsers({ commit, dispatch }, query) {
    commit('SET_SEARCH_QUERY', query);

    await dispatch('fetchManagers');
  },

  async filterManagers({ commit, dispatch }, filter) {
    if (filter.filterName === 'departments') {
      commit('SET_SELECTED_DEPARTMENTS', filter.filterIds);
    }

    await dispatch('fetchManagers');
  },

  async clearFilterManagers({ commit, dispatch }, filterName) {
    if (filterName === 'departments') {
      commit('SET_SELECTED_DEPARTMENTS', []);
    }

    await dispatch('fetchManagers');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
